import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: _ctx.darkMode ? 'dark' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Payment')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClickNative: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["onClickNative"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["color"])
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      style: {"position":"relative","background-color":"var(--ion-color-white)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_row, { style: {"margin":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Invoice balance", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      readonly: "",
                      type: "number",
                      value: (_ctx.total_amount - _ctx.amount_paid).toFixed(2),
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_row, { style: {"margin":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Rounded amount for cash payment", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      readonly: "",
                      type: "number",
                      value: _ctx.rounded_amount,
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_row, { style: {"margin":"0","border":"1px solid #e5ecef","background-color":"white","margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "12",
              lg: "12",
              xl: "12",
              style: {"border-bottom":"1px solid #dedddc"}
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createElementVNode("b", null, "Payment Methods", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8",
              style: {"border-bottom":"1px solid #dedddc","border-right":"1px solid #dedddc","background-color":"#f9f9f9"}
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Cash", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4",
              style: {"border-bottom":"1px solid #dedddc","background-color":"#f9f9f9","padding":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCashClicked())),
                      value: _ctx.cash_amount,
                      onChangeNative: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cash_amount=$event.target.value)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cash_amount=$event.target.value)),
                      type: "number",
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8",
              style: {"border-right":"1px solid #dedddc"}
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Debit/Credit Card", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4",
              style: {"padding":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCardClicked())),
                      value: _ctx.card_amount,
                      onChangeNative: _cache[4] || (_cache[4] = ($event: any) => (_ctx.card_amount=$event.target.value)),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.card_amount=$event.target.value)),
                      type: "number",
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_row, { style: {"margin":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8"
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Amount to be paid", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      readonly: "",
                      type: "number",
                      value: _ctx.amount_to_be_paid,
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_row, { style: {"margin":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "8",
              lg: "8",
              xl: "8"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createElementVNode("b", { style: {"align-items":"center","display":"flex","height":"100%"} }, "Cash to give back to the customer", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "4",
              lg: "4",
              xl: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_input, {
                      readonly: "",
                      type: "number",
                      value: _ctx.cash_back,
                      style: {"text-align":"right"}
                    }, null, 8, ["value"])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_row, { style: {"margin":"0","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "4",
              sm: "4",
              md: "4",
              lg: "4",
              xl: "4"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode(" ")
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addCashAmount(0.05))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "0.05$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addCashAmount(0.1))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "0.10$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addCashAmount(0.25))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "0.25$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addCashAmount(1))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "1$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addCashAmount(2))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "2$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addCashAmount(5))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "5$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addCashAmount(10))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "10$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addCashAmount(20))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "20$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addCashAmount(50))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "50$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "2",
              sm: "2",
              md: "2",
              lg: "2",
              xl: "2",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addCashAmount(100))),
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "100$")
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "6",
              xl: "6",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createElementVNode("button", {
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "TAKE CARD PAYMENT", -1)
              ]), undefined, true),
              _: 1
            }),
            _createVNode(_component_b_col, {
              cols: "12",
              sm: "12",
              md: "6",
              lg: "6",
              xl: "6",
              style: {"padding":"0 5px"}
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createElementVNode("button", {
                  class: "btn btn-danger btn_custom",
                  type: "button",
                  style: {"width":"100%","height":"50px","margin":"20px 0px","margin-top":"0px","background-color":"#02a9f4","color":"white"}
                }, "TAKE CASH PAYMENT", -1)
              ]), undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ], 64))
}